(function () {
    'use strict';

    angular.module("imApp").factory("productLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductLanguages: function (parms) {
                return $ihttp.post({
                    method: 1082,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
